
import { memo, useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { getShareHoldingPatternData } from "../../redux/actions/marketOverview";
import { getAssetExchangeNameFromMktSegId, getDecryptLocalStorage } from "../../utils/global_functions";
import { LOCAL_STORAGE_KEYS, THEME_TYPE, WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { Container } from "react-bootstrap";
import ZeroStates from "../ZeroStates";
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const ShareHolding = ({expandScripOverviewModel}) => {
  const dispatch = useDispatch();
  const strActiveTheme = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.THEME);

  const scripOverviewData = useSelector(
    (state) => state.marketOverview.scripOverviewData
  );
  const shareHoldingPatternData = useSelector(
    (state) => state.marketOverview.shareHoldingPatternData
  );

  useEffect(() => {
    if (shareHoldingPatternData?.length === 0) {
      dispatch(
        getShareHoldingPatternData({
          mktSegmentId: getAssetExchangeNameFromMktSegId(
            scripOverviewData[WATCHLIST_GRID_INDEX.SEGMENT_ID]
          ),
          // BT-114569 : Functional Implementation : Vaibhav Singh : 01-07-2023 : fixed for apicall when inline search is triggered
          nToken: scripOverviewData[WATCHLIST_GRID_INDEX.TOKEN],
          jtenantToken: 1
        })
      );
    }
  }, [dispatch, scripOverviewData, shareHoldingPatternData]);

  const chartData = {
    labels: ["FII", "MF", "Others", "Promoter"],
    datasets:  [
      {
        label: shareHoldingPatternData?.data?.ResponseObject?.resultset? `Holdings for YRC ${shareHoldingPatternData?.data?.ResponseObject?.resultset[0]?.YRC}`:'',
        data: shareHoldingPatternData?.data?.ResponseObject?.resultset? [
          parseFloat( shareHoldingPatternData?.data?.ResponseObject?.resultset[0].FIIHolding)?.toFixed(2),
          parseFloat(shareHoldingPatternData?.data?.ResponseObject?.resultset[0].MutualFundHolding)?.toFixed(2),
          parseFloat(shareHoldingPatternData?.data?.ResponseObject?.resultset[0].Others)?.toFixed(2),
          parseFloat(shareHoldingPatternData?.data?.ResponseObject?.resultset[0].PromoterHolding)?.toFixed(2),
        ]:[],
        // Define colors directly
        backgroundColor:strActiveTheme === THEME_TYPE.DARK 
          ? ['#5f87c2', '#2862c3', '#f1cb8d', '#6ea9e1'] // Colors for dark mode
          : ['#5f87c2', '#2862c3', '#f1cb8d', '#6ea9e1'], // Colors for light mode
        borderWidth: 0,
      },
    ],
  };

  const chartOptions = {
    cutout: '70%',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom", // Legend at the bottom
        labels: {
          generateLabels: (chart) => {
             const data = chart.data; 
             return data.labels.map((label, index) => { 
             const value = data.datasets[0].data[index];
             return { text: `${label}: ${value}%`, // Combine label and value
           fillStyle: data.datasets[0].backgroundColor[index], strokeStyle: data.datasets[0].backgroundColor[index], hidden: false, index: index, };
           })}
        },
        color:strActiveTheme === THEME_TYPE.DARK ? "#ffffff" : "#000000", // Legend text color
      },
      tooltip: {
        displayColors: false, // Disable color boxes
        backgroundColor: strActiveTheme === THEME_TYPE.DARK ? "#333333" : "#ffffff", // Tooltip background color
        titleColor: strActiveTheme === THEME_TYPE.DARK ? "#ffffff" : "#000000", // Tooltip title color
        bodyColor: strActiveTheme === THEME_TYPE.DARK ? "#ffffff" : "#000000", // Tooltip text color
        callbacks: {
          title: function () {
            return ''; // Empty string to hide title
          },
          label: function (tooltipItem) {
            const label = chartData.labels[tooltipItem.dataIndex];
            const value = tooltipItem.raw;
            return `${label}: ${value}%`;
          },
        },
      },
      datalabels: {
        display: false, // Disable data labels
      },
    },
    layout: {
      padding: 20, // Add some padding around the chart
    },
  };

   const canvas = document.querySelector('#chart-canvas')
  useEffect(() => {
        if (expandScripOverviewModel) {
           
            if (canvas) {
                canvas.style.height = '79%'
                canvas.style.width = '99%'
            } else { }
        }
        else { 
        }
    }, [expandScripOverviewModel,canvas])

  return (
    <>
      <Container fluid className='p-0 mt-3'>
        <div className='scripoverview-fieldset'>
            <div className='scripoverview-legend'>SHARE HOLDINGS</div>
            {(shareHoldingPatternData?.data?.ResponseObject?.resultset?.length) ?
            <div style={{with:'100%',height: expandScripOverviewModel?"570px":'350px'}}>
                <Pie id='chart-canvas' data={chartData} options={chartOptions} />
                </div>
              :
              <div className='zero-state-alerts zero-state-alerts-xl'>
                <ZeroStates subText="Could not find any data" icon='icon-64 icon-nodata mb-3 mrgauto' />
              </div>
            }
        </div>
      </Container>
    </>
  );
};

export default memo(ShareHolding);